import { render, staticRenderFns } from "./CampaignList.vue?vue&type=template&id=29cb8180&scoped=true&"
import script from "./CampaignList.vue?vue&type=script&lang=ts&"
export * from "./CampaignList.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignList.vue?vue&type=style&index=0&id=29cb8180&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cb8180",
  null
  
)

export default component.exports